<script>
  // This is a standalone layout without the navbar
</script>

<div class="flex flex-col min-h-screen">
  <slot />
</div>
